<template>
  <Nav :title="'在线咨询'"></Nav>
</template>

<script>
import Nav from '../../components/nav.vue'
export default {
    components:{
        Nav
    },
    mounted(){
      this.getmeiqiaid()
    },
   methods:{
        async getmeiqiaid() {
      try {
        this.$showLoad();
        let url = "/hospitalconf/index/querymeiqiaid";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            this.$hideLoad();
            if(data.data){
                this.geticon(data.data)
            }
           console.log(data)
          }
        );
      } catch (error) {}
    },
       geticon(entid){
       (function(a, b, c, d, e, j, s) {
        a[d] = a[d] || function() {
            (a[d].a = a[d].a || []).push(arguments)
        };
        j = b.createElement(c),
            s = b.getElementsByTagName(c)[0];
        j.async = true;
        j.charset = 'UTF-8';
        j.src = 'https://static.meiqia.com/widget/loader.js';
        s.parentNode.insertBefore(j, s);
    })(window, document, 'script', '_MEIQIA');
    _MEIQIA('entId', entid);
     _MEIQIA('init');  //初始化
    _MEIQIA('showPanel');
       },
   }
}
</script>

<style>

</style>